import React from 'react'
import QuoteGenerator from './Component/Quotegenerator'

function App() {
  return (
    <div>
      <QuoteGenerator />
    </div>
  )
}

export default App